import React from 'react';
import { SnoreStopAdvertorial } from './pages/SnoreStopAdvertorial';
export function App() {
  return <SnoreStopAdvertorial data-id="element-0" />;
}